import { render, staticRenderFns } from "./z-card.vue?vue&type=template&id=736a226d&"
import script from "./z-card.vue?vue&type=script&lang=js&"
export * from "./z-card.vue?vue&type=script&lang=js&"
import style0 from "./z-card.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports